import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, Col, Row, Form, Button, CardBody, CardHeader, CustomInput, Badge } from 'reactstrap';
import { getAPI } from "../../Base/API";
import { ErrorAlert } from "../../Common/ErrorAlert";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import moment from 'moment';
import { CustomDateRangePicker } from '../../Base/Common/CustomReactDates';
import { FormatAmountNumber } from '../../Base/Common/CommonUIComponents';
import { handleNotification } from '../../Base/Notification';
import { CustomTable } from '../../Base/Common/CustomTable';
import { Pagination, ResultsPerPage, TotalResults } from '../../Base/Common/PaginationComponents';


class Shift4Charges extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: [],
            block: false,
            totalCount: 0,
            limit: 10,
            startingAfter: null,
            endingBefore: null,
            page: 0,
            charges: []
        }
    }

    componentDidMount() {
        this.getCharges()
    }

    getCharges = (endingBefore, startingAfter) => {
        this.setState({ block: true });

        var params = `?startDate=${moment(this.props.startDate).format("YYYY-MM-DD")}&endDate=${moment(this.props.endDate).format("YYYY-MM-DD")}&limit=${this.state.limit}`;

        if (endingBefore) params += `&endingBefore=${endingBefore}`;
        else if (startingAfter) params += `&startingAfter=${startingAfter}`;

        getAPI(result => {
            const { data, error } = result;
            var errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors?.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }

                var charges = data.response[0]?.list;
                var totalCount = data.response[0]?.totalCount;
                var hasMore = data.response[0]?.hasMore;
                var endingBefore = null;
                var startingAfter = null;

                if (charges?.length > 0) {
                    var page = this.state.page; 
                    
                    if (page === 0 && totalCount > this.state.limit) startingAfter = charges[charges.length - 1]?.id;
                    if (page !== 0) {
                        if (hasMore) {
                            startingAfter = charges[charges.length - 1]?.id;
                        }
                            
                        endingBefore = charges[0]?.id;
                    }
                }
                

                this.setState({ 
                    charges, totalCount,
                    hasMore, startingAfter, endingBefore, 
                    block: false, 
                    error: errorMessage 
                });
            }
            else {
                this.setState(({ block: false, error: errorMessage }));
            }
        }, `/api/Price/Shift4/v1/charges` + params);
    }

    doSearch = (evt) => {
        evt.preventDefault();

        this.setState({ page: 0 }, () => this.getCharges());
    }

    handlePagination = (direction) => {
        const { endingBefore, startingAfter, page } = this.state;

        if (direction === -1 && endingBefore) {
            this.setState(
                { page: page - 1 },
                () => this.getCharges(endingBefore, null)
            );
        } else if (direction === 1 && startingAfter) {
            this.setState(
                { page: page + 1 },
                () => this.getCharges(null, startingAfter)
            );
        }
    }
        
    changePageSize = (evt) => {
        const { value } = evt.target;

        if (this.state.limit !== value) {
            this.setState({ limit: value, page: 0 }, _ => this.getCharges());
        }
    }

    render() {
        const { block, charges, totalCount, limit, endingBefore, startingAfter, page } = this.state;

        const columns = [
            {
                dataField: 'id',
                text: "Id"
            },
            {
                dataField: 'created',
                text: this.props.intl.formatMessage({ id: "generic.Date" }),
                formatter: (cell) => moment.unix(cell).format("MM/DD/YYYY")
            },
            {
                dataField: 'type',
                text: this.props.intl.formatMessage({ id: "generic.Type" })
            },
            {
                dataField: 'amount',
                text: this.props.intl.formatMessage({ id: "generic.Amount" }),
                formatter: (cell, row) => <FormatAmountNumber value={(cell / 100).toFixed(2)} currency={row.currency} />
            },
            {
                dataField: 'amountRefunded',
                text: this.props.intl.formatMessage({ id: "PaymentManagement.Refund" }),
                formatter: (cell, row) => <FormatAmountNumber value={(cell / 100).toFixed(2)} currency={row.currency} />
            }, 
            {
                dataField: 'description',
                text: this.props.intl.formatMessage({ id: "generic.Description" })
            },
            {
                dataField: 'customerId',
                text: this.props.intl.formatMessage({ id: "PaymentManagement.Customer" })
            },
            {
                dataField: 'captured',
                text: this.props.intl.formatMessage({ id: "PaymentManagement.Captured" }),
                formatter: (cell, row) => 
                    <CustomInput
                        type="checkbox"
                        className="mb-1"
                        checked={cell}
                        disabled
                        id={`capture_${row.id}`}
                    />
            },
            {
                dataField: 'refunded',
                text: this.props.intl.formatMessage({ id: "PaymentManagement.Refunded" }),
                formatter: (cell, row) => 
                    <CustomInput
                        type="checkbox"
                        className="mb-1"
                        checked={cell}
                        disabled
                        id={`capture_${row.id}`}
                    />
            },
            {
                dataField: 'disputed',
                text: this.props.intl.formatMessage({ id: "PaymentManagement.Disputed" }),
                formatter: (cell, row) => 
                    <CustomInput
                        type="checkbox"
                        className="mb-1"
                        checked={cell}
                        disabled
                        id={`capture_${row.id}`}
                    />
            },
            {
                dataField: 'status',
                text: this.props.intl.formatMessage({ id: "generic.Status" }),
                formatter: (cell) => {
                    const status = this.props.chargeStatus.find(status => status.value === cell);

                    if (status) {
                        return <Badge color={status.color}>{status.label}</Badge>
                    }
                }
            }
        ]


        return (
            <BlockUi tag="div" blocking={block}>
                <ErrorAlert error={this.state.error} />
                
                <Card className="border-0 shadow ">
                    <CardHeader className="bg-white border-bottom py-2">
                        <div><span className="far fa-credit-card mr-2"> </span> <FormattedMessage id="PaymentManagement.Charges" /> </div>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={this.doSearch} className="mb-4">
                            <Row className="align-items-end">
                                <Col>
                                    <CustomDateRangePicker
                                        required
                                        startDate={this.props.startDate}
                                        startDateId="your_unique_start_date_id_announcement"
                                        isOutsideRange={day => day > moment()}
                                        endDate={this.props.endDate}
                                        endDateId="your_unique_end_date_id_announcement"
                                        onDatesChange={(startDate, endDate) => this.props.handleDates({ startDate, endDate })}
                                        numberOfMonths={1}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    <Button className="btn btn-host btn-sm " type="submit">
                                        <i className="fa fa-search" />
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                        <Row>
                            <Col>                            
                                <CustomTable
                                    data={charges || []}
                                    columns={columns}
                                    search={false}
                                    small={true}
                                    exportCSV={false}
                                    hideSizePerPage={true}
                                    sizePerPage={limit}
                                    hasPagination={false}
                                />
                            </Col>
                        </Row>
                        {totalCount > 0 ?
                            <div className="py-4 d-flex align-items-center">
                                <div className='w-50' style={{maxWidth: '50%'}}>
                                    <ResultsPerPage
                                        changeSizePerPage={this.changePageSize}
                                        pageSize={limit}
                                    />

                                    {!global.isMobile ?
                                        <span className="ml-2">
                                            <TotalResults
                                                end={page * limit + charges.length}
                                                start={page * limit + 1}
                                                total={totalCount}
                                            />
                                        </span>
                                    :''}
                                </div>
                                <div className="w-50 d-flex justify-content-end" style={{maxWidth: '50%'}}>
                                    <Pagination
                                        isPrevDisabled={!endingBefore}
                                        isNextDisabled={!startingAfter}
                                        currentPage={page + 1}
                                        handlePrevButton={() => this.handlePagination(-1)}
                                        handleNextButton={() => this.handlePagination(1)}
                                    />
                                </div>
                            </div>
                        : ''}
                    </CardBody>
                </Card>
            </BlockUi>
        )
    }
}

export default injectIntl(Shift4Charges);